import React from 'react';
import { combinazioni, colonneSistema, riassunto } from '../../services/profiloDiGioco';
import i18next from 'i18next';
import {lingua} from '../../preferenze';

const euro = (n) => Number(n || 0).toLocaleString(lingua(), {
  minimumFractionDigits: 2, maximumFractionDigits: 2,
});

const NOMI = ['', 'Singole', 'Doppie', 'Triple'];
const nomeDi = (k) => NOMI[k] || `${k}-uple`;

/**
 * Le grandezze di colonna di un sistema.
 *
 * Ogni riga si SPUNTA: scrivere un importo non basta a dire che quella
 * grandezza si gioca, e usare l'importo come interruttore significa che
 * cancellandolo per correggerlo la riga sparisce dal conto. La spunta dice
 * cosa si gioca, l'importo quanto.
 *
 * Accanto, quella riga da sola quanto puo' pagare: minimo e massimo, col
 * proprio bonus, perche' una quaterna e una cinquina non prendono lo stesso
 * scalino.
 *
 * Con N selezioni e F fisse le colonne di grandezza k sono C(N-F, k-F), e le
 * righe sotto F non si mostrano affatto: con due fisse le singole non
 * esistono, e una riga a zero farebbe solo chiedere perche'.
 */
export default function TabellaSistema({
  quote,
  chiaviFisse,
  scalini,
  /* Oltre quanti giorni una partita non conta per lo scalino. Arriva da
     Schedina insieme agli scalini: senza, questa tabella mostrerebbe un bonus
     piu' alto di quello che il server paghera', e sono la stessa schermata. */
  giorniBonus,
  attive,
  importi,
  onAttiva,
  onImporto,
}) {
  const selezioni = quote.length;
  const fisse = chiaviFisse.length;

  const righe = [];
  for (let k = 1; k <= selezioni; k += 1) {
    if (k < fisse) continue;
    const quante = combinazioni(selezioni, fisse, k);
    if (quante <= 0) continue;
    righe.push({ k, quante });
  }

  return (
    <div className="lvc-sistema">
      {/* L'INTESTAZIONE non e' decorazione: senza, "119,92 – 943,88" non dice
          quale dei due e' il minimo. Chi ha fatto la schedina lo sa, il
          cliente no. */}
      <div className="lvc-sistema-riga lvc-sistema-intestazione">
        <span className="lvc-sistema-nome">{i18next.t('Colonne')}</span>
        <span className="lvc-sistema-comb">n.</span>
        <span className="lvc-sistema-importo-testa">{i18next.t('Importo')}</span>
        <span className="lvc-sistema-cifra">{i18next.t('Vince min')}</span>
        <span className="lvc-sistema-cifra">{i18next.t('Vince max')}</span>
      </div>

      {righe.map(({ k, quante }) => {
        const attiva = attive.indexOf(k) !== -1;
        const importo = Number(importi[k]) || 0;
        let conti = null;
        if (attiva && importo > 0) {
          conti = riassunto(colonneSistema(quote, chiaviFisse, [k]), importo, scalini, giorniBonus);
        }
        return (
          <div className={`lvc-sistema-riga${attiva ? ' lvc-sistema-riga--attiva' : ''}`} key={k}>
            <label className="lvc-sistema-nome">
              <input
                type="checkbox"
                checked={attiva}
                onChange={() => onAttiva && onAttiva(k)}
              />
              {nomeDi(k)}
            </label>

            <span className="lvc-sistema-comb">{quante}</span>

            <input
              className="lvc-sistema-importo"
              type="number"
              inputMode="decimal"
              min="0"
              step="0.10"
              disabled={!attiva}
              aria-label={i18next.t('Importo per colonna, {{v0}}', {v0: nomeDi(k)})}
              value={importi[k] === undefined ? '' : importi[k]}
              onChange={(e) => onImporto && onImporto(k, e.target.value)}
            />

            <span className="lvc-sistema-cifra">
              {conti ? `${euro(conti.vincitaMin)} €` : '—'}
            </span>
            <span className="lvc-sistema-cifra">
              {conti ? `${euro(conti.vincitaMax)} €` : '—'}
            </span>
          </div>
        );
      })}

      {fisse > 0 && (
        <div className="lvc-sistema-nota">
          {fisse === 1 ? i18next.t('Una fissa: sta') : `${fisse} fisse: stanno`}{' '}{i18next.t('in tutte le colonne, quindi le combinazioni si fanno sulle altre')}
          {` ${selezioni - fisse} `}
          {i18next.t('selezioni.')}
        </div>
      )}
    </div>
  );
}
